import React, { useRef } from "react";
import css from "./index.module.less";
import { getString } from "../index";
import QRCode from "qrcode.react";
import { DownloadButton } from "../components/DownloadButton";
import Constant from "../utils/Constant";
import { usePageContext } from "./index";
export interface DownloadAppProps {
  showQRCode?: boolean;
  style?: React.CSSProperties;
  titleColor?: string;
}

const $st = getString;

const DownloadApp = (props: DownloadAppProps) => {
  const { style, titleColor } = props;
  const rootRef = useRef(null);

  const { downloadClickReport } = usePageContext();

  return (
    <div className={css.download_app} style={style} ref={rootRef}>
      <div className={css.download_app_left}>
        <h3>
          <div
            className={`${css.download_app_title} ${css.download_app_title_home}`}
            style={{ color: titleColor }}
          >
            {getString("homepage_downloadapp_title")}
          </div>
        </h3>
        <p>iOS</p>
        <div className={css.center_container}>
          <div>
            <div className={css.download_row}>
              <DownloadButton
                icon={require("../images/ic_appstore.png")}
                title={$st("down_from")}
                desc={"App Store"}
                url={$st("appstore_url")}
                onClick={() => downloadClickReport("app_store_btn")}
              />
              <DownloadButton
                icon={require("../images/icon_test_flight.svg")}
                title={$st("down_from")}
                desc={"TestFlight"}
                url={$st("testflight_url")}
                onClick={() => downloadClickReport("testflight_btn")}
                invert
              />
            </div>
            <p style={{ marginTop: 40 }}>Android</p>
            <div className={css.download_row}>
              <DownloadButton
                icon={require("../images/ic_googleplay.png")}
                title={$st("down_from")}
                desc={"Google Play"}
                url={$st("gp_url")}
                onClick={() => downloadClickReport("google_play")}
              />
              <DownloadButton
                icon={require("../images/ic_apk2.png")}
                title={$st("down_apk")}
                desc={"Android"}
                url={"https://static.pionex.com/apk/pionex.apk"}
                onClick={() => downloadClickReport("apk")}
              />
            </div>
            <div className={css.download_row} style={{ marginTop: "20px" }}>
              <DownloadButton
                icon={require("../images/icon_samsung_store.svg")}
                title={$st("down_from")}
                desc={"Samsung Store"}
                url={$st("samsung_store_url")}
                onClick={() => downloadClickReport("samsung_store")}
              />
            </div>
          </div>
          <div className={css.qrcode_container}>
            <QRCode
              value={`https://download.pionex.com/${window.location.search}${window.location.search ? "&from=qr" : "?from=qr"}`} //value参数为生成二维码的链接
              size={154} //二维码的宽高尺寸
              fgColor="#000000" //二维码的颜色
            />
            <span>{$st("scan_qr_download")}</span>
          </div>
        </div>
      </div>
      <div className={css.download_app_right}>
        <img
          className={css.img}
          src={require("../images/app&web_pic_cut.png")}
          alt=""
        />
      </div>
    </div>
  );
};

export default DownloadApp;
